import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import Loader from "../../../loader";
import { useDispatch, useSelector } from "react-redux";
import { registerSchema } from "../../../../utils/schema";
import ErrorMessage from "../../../form/ErrorMessage";
import { registerToday } from "../../../../redux/features/coach/actions/authAction";
import { useEffect } from "react";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

const ClaimYourSpot = ({
  isOpen,
  setClose,
  isSuccessModal,
  setIsSuccessModal,
  id
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const roles = [
    "Business Owner",
    "Marketing Manager",
    "Sales Professional",
    "Consultant",
    "Freelancer",
    "Student",
    "Other",
  ];

  const normalizePhoneValue = (value) => {
    if (!value) return "";
    const trimmed = String(value).trim();
    if (!trimmed) return "";
    if (trimmed.startsWith("+")) return trimmed;
    const digits = trimmed.replace(/\D/g, "");
    if (!digits) return "";
    return `+${digits}`;
  };

  const { isLoading } = useSelector((state) => state?.coach?.auth);

  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "+230",
    role: "",
    linkedin_url: "",
    source: "",
    webinar_id: id
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.style.position = "relative";
    };
  }, [isOpen]);

  const handleFormSubmit = (values) => {
    const callback = (response) => {
      if (response.success) {
        setClose(false);
        setIsSuccessModal(true);
      }
    };
    dispatch(registerToday({ payload: values, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div
        className="modal fade modal-xl d-block show  "
        id="ct_claim_your_spot"
        tabindex="-1"
        aria-labelledby="ct_claim_your_spotLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                onClick={() => {
                  setClose(false);
                }}
                className="btn-close ct_close_position_right12"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <section className="ct_signup_main py-3 pb-lg-5 ">
                <div className="container-fluid">
                  <div className="row align-items-center">
                    <div className="col-xxl-5 col-xl-5 col-lg-5 mb-4 mb-lg-0 d-none d-lg-block">
                      <div className="ct_signup_left_img">
                        <img src="/assets/img/Rectangle_4179344.png" alt="" />
                      </div>
                    </div>
                    <div className="col-xxl-7 col-xl-7 col-lg-7 mb-4 mb-lg-0 mx-auto pe-0">
                      <div className="ct_signup_right_content bg-transparent ct_px_100_new px-3 ct_custom_scroll">
                        <div className="ct_signup_logo mb-3">
                          <img src="/assets/img/Nuvio_logo.png" alt="" />
                        </div>
                        <div className="mt-0 text-center">
                          <h2 className="ct_fs_24 ct_fw_600 mb-2">
                            You're almost In! 🙌
                          </h2>
                          <p className="mb-0 ct_orange_text">
                            You've just taken the first step toward turning your
                            skills into real influence, income, and impact.
                          </p>
                        </div>
                        <Formik
                          initialValues={initialValues}
                          validationSchema={registerSchema}
                          onSubmit={(values, actions) => {
                            handleFormSubmit(values);
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldError,
                            setFieldValue,
                          }) => (
                            <form className="mt-4">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group mb-3">
                                    <label
                                      for=""
                                      className="mb-2 d-block ct_darkblue_text"
                                    >
                                      First Name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ct_input ct_h_35"
                                      placeholder="First name"
                                      id="first_name"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values?.first_name}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName="first_name"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group mb-3">
                                    <label
                                      for=""
                                      className="mb-2 d-block ct_darkblue_text"
                                    >
                                      Last Name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ct_input ct_h_35"
                                      placeholder="Last name"
                                      id="last_name"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values?.last_name}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName="last_name"
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group mb-3">
                                    <label
                                      for=""
                                      className="mb-2 d-block ct_darkblue_text"
                                    >
                                      Email
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ct_input ct_h_35"
                                      placeholder="Email"
                                      id="email"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values?.email}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName="email"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group mb-3">
                                    <label
                                      for=""
                                      className="mb-2 d-block ct_darkblue_text"
                                    >
                                      LinkedIn Profile
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ct_input ct_h_35"
                                      placeholder="LinkedIn profile"
                                      id="linkedin_url"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values?.linkedin_url}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName="linkedin_url"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="form-group mb-3">
                                    <label
                                      for=""
                                      className="mb-2 d-block ct_darkblue_text"
                                    >
                                      Phone Number
                                    </label>
                                    <PhoneInput
                                      id="phone_number"
                                      className="form-control ct_input ct_input_grey_border_1 ct_border_radius_5 ct_h_44"
                                      defaultCountry="MU"
                                      value={normalizePhoneValue(values?.phone_number)}
                                      onChange={(val) => {
                                        const safeVal = val ?? "";
                                        if (
                                          typeof safeVal === "string" &&
                                          safeVal.length > 2 &&
                                          isValidPhoneNumber(safeVal)
                                        ) {
                                          setFieldValue(
                                            "phone_number",
                                            safeVal
                                          );
                                        } else if (
                                          !isValidPhoneNumber(safeVal)
                                        ) {
                                          setFieldError(
                                            "phone_number",
                                            "Please enter valid phone number"
                                          );
                                          setFieldValue(
                                            "phone_number",
                                            safeVal
                                          );
                                        }
                                      }}
                                      onBlur={handleBlur}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName="phone_number"
                                    />
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <div className="form-group mb-3">
                                    <label
                                      for=""
                                      className="mb-2 d-block ct_darkblue_text"
                                    >
                                      What best describes your current
                                      role?(Select one)
                                    </label>
                                    <div className="d-flex flex-column gap-2 position-relative">
                                      <select
                                        className="form-control ct_input ct_h_35"
                                        name="role"
                                        value={values?.role}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      >
                                        <option value={""}>
                                          Select current role
                                        </option>
                                        {roles?.map((item, ind) => (
                                          <option value={item}>{item}</option>
                                        ))}
                                      </select>
                                      <i className="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                    </div>
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName="role"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="form-group mb-3">
                                    <label
                                      for=""
                                      className="mb-2 d-block ct_darkblue_text"
                                    >
                                      How did you hear about NUVIO's webinar?
                                    </label>
                                    <div>
                                      <div className="ct_radio-container">
                                        {[
                                          "Word of mouth",
                                          "Social Media",
                                          "Others",
                                        ].map((option, idx) => (
                                          <div
                                            className="ct_radio-wrapper"
                                            key={idx}
                                          >
                                            <label className="ct_radio-button">
                                              <input
                                                type="radio"
                                                id="option1"
                                                name="source"
                                                value={option}
                                                checked={
                                                  values?.source === option
                                                }
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                              />
                                              <span className="ct_radio-checkmark"></span>
                                            </label>
                                            <p className="mb-0">{option}</p>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName="source"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="text-center mt-3">
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleSubmit();
                                  }}
                                  className="ct_yellow_btn w-100"
                                //   data-bs-toggle="modal"
                                //   data-bs-target="#ct_submit_modal"
                                >
                                  Register Today
                                </a>
                              </div>
                            </form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            {/* <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" className="btn btn-primary">Save changes</button>
      </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ClaimYourSpot;
